"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeAccumulator;
var defaultComparator = function defaultComparator(a) {
  return function (b) {
    if (a < b) {
      return -1;
    }
    if (a == b) {
      return 0;
    }
    return 1;
  };
};

var generateComparatorForKey = function generateComparatorForKey(key) {
  return function (a) {
    var x = key(a);

    return function (b) {
      var y = key(b);

      if (x < y) {
        return -1;
      }
      if (x == y) {
        return 0;
      }
      return 1;
    };
  };
};

function makeAccumulator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      comparator = _ref.comparator,
      key = _ref.key,
      _ref$unique = _ref.unique,
      unique = _ref$unique === undefined ? true : _ref$unique;

  var uniqueIsFunction = typeof unique === 'function';

  if (comparator && key) {
    throw new Error("Both comparator and key cannot be defined");
  }

  if (key) {
    comparator = generateComparatorForKey(key);
  } else if (!comparator) {
    comparator = defaultComparator;
  }

  return function (list, value) {
    if (!list) {
      return [value];
    }

    var seededComparator = comparator(value);
    var low = -1,
        high = list.length;

    while (low !== high - 1) {
      var mid = Math.floor((high - low) / 2 + low);
      var comparison = seededComparator(list[mid]);

      if (comparison > 0) {
        low = mid;
      } else if (comparison === 0) {
        if (unique) {
          var newList = list.slice(0);
          newList[mid] = uniqueIsFunction ? unique(list[mid], value) : value;
          return newList;
        } else {
          return list.slice(0, mid).concat([value]).concat(list.slice(mid));
        }
      } else {
        high = mid;
      }
    }

    return list.slice(0, high).concat([value]).concat(list.slice(high));
  };
}


//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/sorted-immutable-list/lib/sorted_immutable_list.js
// module id = ../../../node_modules/sorted-immutable-list/lib/sorted_immutable_list.js
// module chunks = 1